export const routes = {
  scenario_versions: '/scenario-versions',
  version: (versionId: string): string =>
    `/scenario-versions/version/${versionId}`,
}
